import { queryString } from './utilities/string';
import { ajaxPromise } from './utilities/ajax.js';
const modal = require("tpl/modal.html");

const __list = {
    downloadArr: [],
    downloadHrefArr: [],
    likePage: 1,
    init() {
        __list.id = queryString('id');
        __list.initVideoFun();
        __list.initSwiperFun();
        __list.initTagcloudFun();
    },

    initTagcloudFun() {

        if ($('#tagcloud').length) {
            /*3D标签云*/
            tagcloud({
                selector: "#tagcloud", /*元素选择器*/
                fontsize: 16, /*基本字体大小, 单位px*/
                radius: 140, /*滚动半径, 单位px*/
                mspeed: 'normal', /*滚动最大速度, 取值: slow, normal(默认), fast*/
                ispeed: 'normal', /*滚动初速度, 取值: slow, normal(默认), fast*/
                direction: 360, /*初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...*/
                keep: false          /*鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动*/
            });
        }
    },
    initSwiperFun() {

        if ($('._swiper').length && $('.valbum-list-item').length > 4) {
            new Swiper('._swiper', {
                // loop: true,
                slidesPerView: 'auto',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next'
            });
        }
    },
    initVideoFun() {
        const $video = $('#video');

        if ($video.length) {
            const { url, cover } = $video.data();

            new QPlayer({
                url: url,
                container: document.getElementById("video"),
                autoplay: false,
                noControls: false,
                poster: cover
            });
        }
    },
    reloadPageFun() {
        setTimeout(() => {
            window.location.reload();
        }, 1000)
    },
    collectHandleFun(e) {
        e.preventDefault();
        const $this = $(this),
            { type, state, id } = $this.data(),
            restType = $('input[name="rest_type"]').val(),
            msg = type == 1 ? (state == 1 ? '已收藏' : '已取消收藏') : (state == 1 ? '已点赞' : '已取消点赞');

        ajaxPromise({
            url: '/resource/ajaxSupport',
            data: {
                type: type, // 1=收藏 2=点赞 3=转发
                rest_type: restType, // 1资源类型 2辑类型
                state: type == 3 ? 1 : state, // 1确认 2取消
                id: id || __list.id,
                doview: 1
            }
        }).then(_ => {

            if (type == 3) { // 转发
                __list.openShareModalFun();
                return;
            }

            layer.msg(msg);

            // $this.data('state', state == 1 ? 2 : 1);
            // state == 1 ? $this.addClass('active') : $this.removeClass('active');
            __list.reloadPageFun();
        })
    },
    openShareModalFun() {
        layer.open({
            type: 1,
            title: false,
            area: ["400px", 'auto'],
            offset: 'auto',
            closeBtn: 0,
            shadeClose: true,
            skin: 'yourclass',
            content: modal({ type: 'share' }),
            success: function () {
                socialShare('._common-share', {
                    url: window.location.href,
                    title: $(".detail-name").text(),
                    description: '',
                    wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
                    wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
                    sites: ['wechat', 'qq', 'weibo']
                });
            }
        })
    },
    removeModalFun() {
        layer.closeAll();
    },
    creatRecommendListFun(data) {
        var html = '';

        if (data.length < 4) {
            __list.likePage = 0;
        }

        data.forEach((item) => {
            html += ` <div class="gt-list-item isvideo ${item.collect == 1 ? 'active' : ''}">
                        <a href="/resource/detail?id=${item.id}">
                            <img class="zj-img" src="${item.logo}" alt="">
                            <div class="detail detail-row2">
                                <p class="title fl row1">${item.source_name}</p>
                                <p class="name row1">
                                    <img src="${item.head}" alt="">
                                    ${item.author}
                                </p>
                            </div>
                        </a>
                    </div>`;
        })

        $('._recommendList').html(html);
    },
    changeRecommendListFun() {
        __list.likePage++;

        ajaxPromise({
            url: '/resource/ajaxMayLike',
            data: {
                page: __list.likePage,
                page_size: 4,
                id: __list.id
            }
        }).then((data) => {
            __list.creatRecommendListFun(data);
        })
    },
    downloadHandleFun() {
        const type = $(this).data('type'),
            authentication = Number($('._authentication').val());

        // // 未认证
        // if (!authentication) {
        //     __list.openLayerFun(modal({ type: 'authentication' }));
        //     return;
        // }

        __list.downloadArr = [];

        if (type == 'all') { // 批量下载
            $('._checkItem').each((index, item) => {
                if ($(item).prop('checked')) {
                    __list.downloadArr.push($(item).val());
                    __list.downloadHrefArr.push($(item).data('href'));
                }
            })
        } else {
            __list.downloadArr.push(__list.id);
            __list.downloadHrefArr.push($('input[name="downloadhref"]').val());
        }

        if (__list.downloadArr.length <= 0 && type == 'all') {
            layer.msg('请打开全选或者多选,选择您要批量下载的内容');
            return false;
        }

        __list.openLayerFun(modal({ type: 'download' }));

    },
    openLayerFun(content) {

        layer.open({
            type: 1,
            title: false,
            area: ["660px", 'auto'],
            offset: 'auto',
            closeBtn: 0,
            shadeClose: true,
            skin: 'yourclass',
            content: content
        })
    },
    showDownloadSelectModalFun() {
        __list.removeModalFun();

        layer.open({
            type: 1,
            title: false,
            area: ["660px", 'auto'],
            offset: 'auto',
            closeBtn: 0,
            shadeClose: true,
            skin: 'yourclass',
            content: modal({ type: 'downloadForm' })
        })
    },
    saveDownloadTypeFun() {
        const type = queryString('type');
        const useFor = [];
        const restType = $('input[name="download_type"]').val();
        const checkElse = $('#download8').prop('checked'),
            elseText = $('._elseText').val();

        $('._downLoadType input').each((index, item) => {
            const val = $(item).val();

            if ($(item).prop('checked')) {
                val == '其他' ? useFor.push(elseText) : useFor.push(val);
            }
        })

        if (useFor.length <= 0) {
            layer.msg('请选择您的下载用途');
            return false;
        }

        if (checkElse && !elseText) {
            layer.msg('请填写其他下载用途');
            return false;
        }

        // 单视频下载 用新接口2
        if (__list.downloadArr.length == 1 && restType == 1) {
            ajaxPromise({
                url: '/Download/videoDown',
                type: 'post',
                data: {
                    use_for: useFor.join(','),
                    id: __list.downloadArr[0]
                }
            }).then((data) => {
                __list.removeModalFun();
                //downloadFile([data.url]);
                window.location = data.url;
            })
            return false;
        }

        // 多视频/多挂图/单挂图 用接口1
        ajaxPromise({
            url: '/download/zip',
            type: 'post',
            data: {
                use_for: useFor.join(','),
                ids: __list.downloadArr.join(','),
                rest_type: restType
            }
        }).then((data) => {

            if (data.task_id) {

                // 下载
                __list.removeModalFun();

                layer.msg('资源打包中，请稍后...', {
                    time: 0, //不自动关闭
                    icon: 4,
                    shade: [0.3, '#000']
                })

                __list.getDownloadFileFun(data.task_id);
            } else {
                layer.msg(data.msg);
            }
        })
    },
    getDownloadFileFun(id) {
        let timer = setInterval(() => {
            ajaxPromise({
                url: '/download/getStatus',
                data: {
                    task_id: id
                }
            }).then((data) => {

                if (data.task_status == 3) {
                    layer.msg(data.msg);
                    clearInterval(timer);
                    setTimeout(() => {
                        __list.removeModalFun();
                    }, 1000)
                }

                if (data.zip_url) {
                    __list.removeModalFun();
                    clearInterval(timer);
                    downloadFile([data.zip_url]);
                }
            })
        }, 2000)
    },
    checkItemHandleFun(isChecked, type) {
        $('._checkItem').each((index, item) => {

            isChecked ? $(item).show() : $(item).hide();

            if (type == 'checkAll') {
                $(item).prop('checked', isChecked);
            } else {
                $(item).prop('checked', false);
            }
        })
    },
    checkAllFun() {
        const isChecked = $(this).prop('checked');

        isChecked ? $('#checkPart').prop('checked', false) : '';
        __list.checkItemHandleFun(isChecked, 'checkAll');
    },
    checkPartFun() {
        const isChecked = $(this).prop('checked');

        isChecked ? $('#checkAll').prop('checked', false) : '';
        __list.checkItemHandleFun(isChecked);
    }
}
$(function () {

    __list.init();

    $(document)
        // 详情页-> 收藏
        .on('click', '._detailBtn', __list.collectHandleFun)
        // 关闭弹窗
        .on('click', '._closeModal', __list.removeModalFun)
        // 详情页-> 推荐列表 换一换
        .on('click', '._changeRecommendList', __list.changeRecommendListFun)
        // 下载 -> 下载版权声明弹窗
        .on('click', '._downloadBtn', __list.downloadHandleFun)
        // 下载 -> 下载用途弹窗
        .on('click', '._showDownloadSelectModal', __list.showDownloadSelectModalFun)
        // 下载 -> 下载用途提交
        .on('click', '._saveDownloadBtn', __list.saveDownloadTypeFun)
        // 下载 -> 全选
        .on('change', '#checkAll', __list.checkAllFun)
        // 下载 -> 多选
        .on('change', '#checkPart', __list.checkPartFun)
})